import React from 'react';

import { ApplicationCardItemProps } from './types';
import { SantaLetterApplicationCardItemDetails } from './SantaLetterApplicationCardItemDetails';

type ApplicationCardSelectableItemProps = ApplicationCardItemProps;

export const ApplicationCardItemDetails = (props: ApplicationCardSelectableItemProps) => {
  if (!props.details || typeof props.details !== 'object') {
    return null;
  }

  return <SantaLetterApplicationCardItemDetails details={props.details} />;
};
